import { render, staticRenderFns } from "./SinistersList.vue?vue&type=template&id=c36f0efa&scoped=true"
import script from "./SinistersList.vue?vue&type=script&lang=ts"
export * from "./SinistersList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36f0efa",
  null
  
)

export default component.exports